import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { deleteQuestion } from ".";

export function useDeleteQuestion(){
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: queryKeys.question._def,
        mutationFn: deleteQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false });
        }
    });
}
